import { render, staticRenderFns } from "./BaseFileUploadList.vue?vue&type=template&id=b9d24442"
import script from "./BaseFileUploadList.vue?vue&type=script&lang=js"
export * from "./BaseFileUploadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports